<template>
  <div style="padding-left: 15px;">
    <div class="col hide-on-print">
      <h5 class="text-uppercase mb-0 ml-2">Marcas Comerciais</h5>
      <h6 class="text-uppercase text-muted ls-1 mb-1 ml-2">
        Custo de Compra Fornecedor: {{ commercialBrand.payment_date | formatDate }} 
        | Custo de Compra Calculado: {{ commercialBrand.purchase_cost_date | formatDate}}
      </h6>
    </div>
    <el-table
      v-loading="isLoading"
      class="table-responsive table-striped padded-table"
      header-row-class-name="thead-light"
      :data="commercialProducts"
      max-height="500"
      style="overflow-y: auto;"
    >
      <el-table-column
        fixed
        type="selection"
        sortable
        width="40"
      />
      <el-table-column
        fixed
        class="mt-4"
        label="Nome"
        sortable
        prop="name"
        width="180px"
      />
      <el-table-column
        v-if="$can('index', 'commercial_product')"
        fixed
        class="mt-4"
        label="Embalagem"
        min-width="100px"
        v-slot="{ row }"
      >
        <template>
          <div>
            <base-input
              mask="volume"
              :max="7"
              placeholder="0,00"
              :disabled="!commercial.is_open || !$can('update', 'commercial_product')"
              input-classes="form-control-sm"
              v-model="row.packing"
              @blur="checkForInputChanges(row)"
            />
          </div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="$can('show', 'commercial_product') || $can('update', 'commercial_product')"
        fixed
        min-width="100px"
      >
        <template v-slot:header>
          <div style="text-align: left;">
            <div class="mb-3">Custo</div>
            <div class="mt-n4" style="overflow:hidden">
              <span v-if="commercialBrand.payment_date">{{ commercialBrand.payment_date | formatDate }}</span>
              <span v-else>sem data</span>
            </div>
          </div>
        </template>

        <template v-slot="{ row }">
          <base-input
            mask="money"
            maxlength="23"
            :disabled="!commercial.is_open || !$can('update', 'commercial_product')"
            :max="16"
            input-classes="form-control-sm"
            v-model="row.purchase_price"
            @blur="checkForInputChanges(row)"
          />     
        </template>
      </el-table-column>

      <el-table-column
        v-if="$can('show', 'commercial_product')"
        label="Custo por Embalagem"
        min-width="200px"
        v-slot="{ row }"
      >
        <disabled-monetary-display
          :value="row.cost_per_package"
        /> 
      </el-table-column>
      <el-table-column 
        min-width="100px"
        v-if="$can('show', 'commercial_product')"
      >
        <template v-slot:header>
          <div style="text-align: left;">
            <div class="mb-3">Custo</div>
            <div class="mt-n4" style="overflow:hidden">
              <span v-if="commercialBrand.payment_date">{{ commercialBrand.purchase_cost_date | formatDate }}</span>
              <span v-else>sem data</span>
            </div>
          </div>
        </template>
        <template v-slot="{ row }">
          <disabled-monetary-display
            :value="row.calculated_purchase_cost"
          /> 
        </template>
      </el-table-column>
      <el-table-column
        v-if="$can('show', 'commercial_product')"
        label="Preço vigência atual"
        min-width="200px"
        v-slot="{ row }"
      >
        <disabled-monetary-display
          :value="parseFloat(row.current_price)"
        /> 
      </el-table-column>
      <el-table-column
        :label="month"
        v-for="(month, index) in monthBuy"
        :key="index"
        min-width="250px"
        v-slot="{ row }"
      >
        <disabled-monetary-display
          :value="parseFloat(row.month_payment[month])"
        />        
      </el-table-column>
      <el-table-column
        v-for="(table, index) in commercial && commercial.commercial_table"
        :key="table.value"
        :label="commercial.commercial_table[index].desc_cta"
        min-width="205px"
        v-slot="{ row }"
      >
        <disabled-monetary-display
          :value="parseFloat(row.table_erp_values[commercial.commercial_table[index].desc_cta])"
        />
      </el-table-column>
      <el-table-column
        v-if="$can('destroy', 'commercial_product') || $can('update', 'commercial_product')"
        fixed="right"
        label="Ações"
        v-slot="{ row }"
      >
        <el-dropdown
          trigger="hover"
          class="dropdown"
          style="cursor: pointer;"
        >
          <span
            @click="$event.stopPropagation()"
            class="btn btn-sm btn-icon-only text-success">
            <a><i class="fas fa-ellipsis-v mt-2"></i></a>
          </span>
          <el-dropdown-menu
            class="dropdown-menu dropdown-menu-arrow show"
            slot="dropdown"
          >
            <a 
              v-if="$can('update', 'commercial_product')"
              class="dropdown-item"
              href="#"
              @click="$emit('edit', row); $event.stopPropagation()"  
            >
              Editar produto
            </a>
            <a 
              v-if="$can('update', 'commercial_product')"
              class="dropdown-item"
              href="#"
              @click="$emit('assign-products', row); $event.stopPropagation()"
              :class="commercial.is_open ? '' : 'disabled'"
            >
              Vincular Produtos
            </a>
            <a 
              v-if="$can('destroy', 'commercial_product')"
              class="dropdown-item" 
              href="#" 
              @click="confirmRemoval(row)"
            >
              Excluir Produto
            </a>
          </el-dropdown-menu>
        </el-dropdown>
      </el-table-column>
      <template v-slot:empty>
        <div class="text-warning" v-if="!$can('show', 'commercial_product')"
          >Você não tem permissão para visualizar produto comercial
        </div>
        <div v-else>Sem dados</div>
      </template>
      <template v-slot:append>
        <div ref="endOfTable" style="height: 50px;"></div>
      </template>
    </el-table>
  </div>
</template>

<script>

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
import BaseInput from "../../components/Inputs/BaseInput.vue";
import DisabledMonetaryDisplay from "../../components/Commercial/DisabledMonetaryDisplay.vue";
import swal from "sweetalert2";

export default {
  components: {
    BaseInput,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    DisabledMonetaryDisplay,
  },
  props: {
    commercial: {
      type: Object,
      default: null
    },
    commercialBrand: {
      type: Object,
      default: null
    },
    monthBuy: {
      type: Array,
      default: () => []
    },
    selectedProducts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: false,
      commercialProducts: [],
      currentPage: 1,
      hasMoreData: true,
    };
  },
  mounted() {
    const observer = new IntersectionObserver(
      this.handleIntersection,
      {
        root: null,
        rootMargin: '300px',
        threshold: 0.9
      }
    );
    observer.observe(this.$refs.endOfTable);
  },
  methods: {
    debouncedUpdateProduct(row) {
      clearTimeout(this.updateProductTimeout);

      this.updateProductTimeout = setTimeout(() => {
        this.updateCommercialProduct(row);
      }, 500);
    },
    handleIntersection(entries) {
      const entry = entries[0];
      if (entry.isIntersecting && entry.intersectionRatio > 0) {
        this.getCommercialProducts();
      }
    },
    async getCommercialProducts() {
      if (!this.hasMoreData || this.isLoading) return;
      this.isLoading = true;
      
      try {
        const { data } = await this.$http.secured.get(
          `/api/v2/commercial_products/`,
          {
            params: {
              per_page: 15,
              page: this.currentPage,
              q: {
                commercial_brand_id: this.commercialBrand.id,
              },
            },
          }
        );

        if (data.data.length === 0) {
          this.hasMoreData = false;
        } else {
          this.commercialProducts = [...this.commercialProducts, ...data.data.map((product) => ({
            ...product,
            original_packing: product.packing,
            original_purchase_price: product.purchase_price
            })),
          ];
          this.currentPage++;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    async updateCommercialProduct(row) {
      const commercialProduct = {
        id: row.id,
        packing: row.packing,
        purchase_price: row.purchase_price,
      };

      try {
        const response = await this.$http.secured.patch(
          `/api/v2/commercial_products/${row.id}`,
          { commercial_product: commercialProduct }
        );

        this.replaceUpdatedObject(response.data);
      } catch (error) {
        console.log(error)
        this.$toasted.global.defaultError({ msg: "Erro ao tentar salvar, por favor tente novamente." });
      }
    },
    removeDeletedObject(deletedObject) {
      const index = this.commercialProducts.findIndex(
        (commercialProduct) => commercialProduct.id === deletedObject.id
      );

      this.commercialProducts.splice(index, 1);
    },

    replaceUpdatedObject(updatedObject = null) {
      const index = this.commercialProducts.findIndex(
        (commercialProduct) => commercialProduct.id === updatedObject.id
      );

      if (index !== 1) {
        const original_packing = this.commercialProducts[index].original_packing;
        const original_purchase_price = this.commercialProducts[index].original_purchase_price;
        this.commercialProducts.splice(index, 1, {
          ...updatedObject,
          original_packing,
          original_purchase_price,
        });
      }
    },
    updateSelectedProducts(selectedProducts) {
      this.$emit('update:selectedProducts', selectedProducts)
    },
    async removeCommercialProduct(row) {
      try {
        await this.$http.secured.delete(
          `/api/v2/commercial_products/${row.id}`
        );

        this.removeDeletedObject(row)
      } catch (error) {
        console.error(error);
      }
    },
    async confirmRemoval(commercialProduct) {
      const result = await swal.fire({
        title: 'Deseja excluir essa condição comercial? ',
        showCancelButton: true,
        confirmButtonColor: '#F5365C',
        cancelButtonColor: '#8898aa',
        confirmButtonText: 'Excluir',
        cancelButtonText: 'Voltar',
      })

      if (result.isConfirmed) {
        await this.removeCommercialProduct(commercialProduct)
        this.$toasted.global.defaultSuccess({msg: "Produto removido com sucesso!"});
      }
    },
    removeBrand(row) {
      this.$http.secured
        .delete(`/api/v1/brands/${row.id}`, { params: { unscoped: true } })
        .then((response) => {
          this.getBrands(null, null, this.commercial && this.commercial.id);
          this.$toasted.global.defaultSuccess();
        })
        .catch((error) => {
          this.setError(error, "Cannot remove quantitative");
        });
    },
    handleSuccessMessage() {
      this.$toasted.global.defaultSuccess({ msg: "Alteração foi salva com sucesso!" });
    },
    checkForInputChanges(row) {
      if (row.packing !== row.original_packing || row.purchase_price !== row.original_purchase_price) {
        this.handleSuccessMessage()
        this.debouncedUpdateProduct(row);
        if (row.packing !== row.original_packing) row.original_packing = row.packing
        if (row.purchase_price !== row.original_purchase_price) row.original_purchase_price = row.purchase_price
      }
    },

  },
  watch: {
  },
  computed: {
    tablesErp() {
      if (this.commercial && !this.commercial.commercial_table) return [];

      return this.commercial && this.commercial.commercial_table;
    },
  }
};
</script>

<style lang="scss">
  .padded-table td .cell{
    padding: 0 8px !important;
  }
</style>